import { ExternalLink } from "../common";
import type { FaqSection } from "./types";

const platformFeaturesSection: FaqSection = {
  id: "features",
  title: "Platform Features & Technical Capabilities",
  faqs: [
    {
      question: "Can Enerflo connect to our internal systems via API?",
      answer: (
        <p>
          Yes. Enerflo offers both a REST API and a GraphQL API, as well as webhooks for real-time updates. The best
          option depends on your integration needs. Technical documentation is available at{" "}
          <ExternalLink href="https://docs.enerflo.io/docs/welcome">docs.enerflo.io</ExternalLink>.
        </p>
      ),
    },
    {
      question: "What makes Enerflo different from other solar software platforms?",
      answer: (
        <p>
          Enerflo is the only platform that combines sales, installation, and customer engagement tools in a single
          ecosystem, with deep lender integrations and process-error prevention features like Title Checks and Smart
          Pulls.
        </p>
      ),
    },
    {
      question: "Does Enerflo offer white-label proposals?",
      answer: (
        <p>
          Yes. Enerflo allows companies to fully brand their solar proposals, including logos, color schemes, content
          and custom pricing.
        </p>
      ),
    },
    {
      question: "Is Enerflo secure and compliant?",
      answer: (
        <p>
          Yes. Enerflo uses industry-standard encryption, is SOC 2 certified, follows best practices for data privacy,
          and complies with relevant solar financing partner requirements.
        </p>
      ),
    },
  ],
};

export default platformFeaturesSection;
